module.exports = __webpack_public_path__ + "static/media/img_party.93c0297e.png";